<section>
    <ispm-patient-bar [patientId]="patientId"></ispm-patient-bar>
    <section class="pt-navigation-context">
        <dls-tabs class="pt-primary-navigation ispm-tabs" *ngIf="type === 'tab'">
            <a *ngFor="let tabs of (tabsTitles$ | async)" (click)="onTabChanged(tabs)"
               class="{{cssClassFormat(tabs.name)}}"
               [ngClass]="{'pt-selected':tabs.name === selectedTabName}">
                <span>{{tabs.name | translate}}</span>
            </a>
        </dls-tabs>

        <dls-springboard (change)="onTabChanged($event)" #springboard>
            <dls-springboard-group>
                <dls-springboard-item *ngFor="let tabs of (tabsTitles$ | async)"
                                      [value]="tabs"
                                      [selected]="selectedTabName === tabs.name">
                    <label>{{tabs.name | stringTranslate}}</label>
                </dls-springboard-item>
            </dls-springboard-group>
        </dls-springboard>
        <div class="springboard-wrapper" *ngIf="type === 'dropdown'">
            <label><b><dls-icon class="pt-icon-left"></dls-icon> Dashboard:     </b></label>
            <button dlsButton class="pt-icon pt-quiet" [dlsSpringboardPopup]="springboard">
                <label><u>{{selectedTabName | stringTranslate}}</u></label>
            </button>
        </div>
    </section>
    <div class="floating-panel-button-wrapper" *ngIf="selectedTabName">
        <dls-toggle-group mode="radio">
            <button dlsToggleButton name="dashboard" [class.pt-selected]="!isTrendsActive" value="left"
                    [(ngModel)]="isTrendsActive" (click)="toggleDashboardAndTrends(false)">
                {{'Dashboard' | stringTranslate}}
            </button>
            <button dlsToggleButton name="trends" value="center" [class.pt-selected]="isTrendsActive"
                    [(ngModel)]="isTrendsActive" (click)="toggleDashboardAndTrends(true)">
                {{'Historical Trends' | stringTranslate}}
            </button>
        </dls-toggle-group>
        <ispm-clinical-trends-filter *ngIf="isTrendsActive"></ispm-clinical-trends-filter>
    </div>
    <ispm-layout-engine [params]="layoutParams" [isScrollable]="isScrollable"></ispm-layout-engine>

</section>
